"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _stringField = _interopRequireDefault(require("./stringField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var listField = function listField(value, options) {
  var isString = typeof value === 'string' && value !== '';
  if (!Array.isArray(value) && !isString) return '';
  var separator = (options === null || options === void 0 ? void 0 : options.separator) || ',';
  var array = isString ? value.split(separator) : value;
  var formatted = array.map(function (element) {
    return (0, _stringField["default"])(element, options === null || options === void 0 ? void 0 : options.stringOptions);
  }).filter(Boolean);
  if (options !== null && options !== void 0 && options.shouldSort) formatted = formatted.sort(function (a, b) {
    return a > b ? 1 : -1;
  });
  return formatted.join(separator);
};
var _default = exports["default"] = listField;